import useGetExaminations, { getExaminationsDocument } from './useGetExaminations';

export default useGetExaminations;
export { getExaminationsDocument };
